import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import ForgotPasswordForm from './components/auth/ForgotPasswordForm';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import StorageTest from './components/StorageTest';
import Settings from './pages/Settings';
import Help from './pages/Help';
import Migrate from './pages/Migrate';
import AcceptInvitation from './pages/AcceptInvitation';
import ScrollToTop from './components/layout/ScrollToTop';
import CookieBanner from './components/ui/CookieBanner';
import MetaPixelRouteTracker from './components/analytics/MetaPixelRouteTracker';
import MetaPixelPurchaseTracker from './components/analytics/MetaPixelPurchaseTracker';
import { initializeOneSignal } from './services/onesignal';
import { useMetaPixel } from './hooks/useMetaPixel';
import { useClarity } from './hooks/useClarity';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';

// Import the original PropertyCheckPro component (temporarily renamed)
import PropertyCheckProOriginal from './App_old';

// This is a temporary wrapper that will be replaced
// For now, we're keeping the original app functional while adding auth
function App() {
  useClarity();
  useGoogleAnalytics();
  useMetaPixel();

  // Initialize OneSignal on app load
  useEffect(() => {
    initializeOneSignal();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <MetaPixelRouteTracker />
        <MetaPixelPurchaseTracker />
        <CookieBanner />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />

          {/* Accept tenant invitation - public/protected hybrid */}
          <Route path="/accept-invitation" element={<AcceptInvitation />} />

          {/* Test route for Storage */}
          <Route
            path="/test-storage"
            element={
              <ProtectedRoute>
                <StorageTest />
              </ProtectedRoute>
            }
          />

          {/* Settings route */}
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />

          {/* Help route */}
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <Help />
              </ProtectedRoute>
            }
          />

          {/* Migration route */}
          <Route
            path="/migrate"
            element={
              <ProtectedRoute>
                <Migrate />
              </ProtectedRoute>
            }
          />

          {/* Protected routes - original app */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <PropertyCheckProOriginal />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
